import ReactDOM from 'react-dom'
import React from 'react'

import { ToastApp } from './ToastApp'
import { ToastPayload } from './toast-reducer'

const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined'

const PORTAL_ID = 'flora-toast-portal'

class ToasterBuilder {
  notify!: (options: ToastPayload) => void
  closeAll!: () => void
  portal: Element | undefined

  constructor() {
    /* istanbul ignore else */
    if (!isBrowser) {
      return
    }

    this.portal = this.getPortal()

    ReactDOM.render(
      <ToastApp
        bind={({
          notify,
          closeAll,
        }: {
          notify: (options: ToastPayload) => void
          closeAll: () => void
        }) => {
          this.notify = notify
          this.closeAll = closeAll
        }}
      />,
      this.portal,
    )
  }

  getPortal() {
    let portalElement = document.querySelector(`#${PORTAL_ID}`)

    /* istanbul ignore else */
    if (!portalElement) {
      const newPortal = document.createElement('div')

      newPortal.setAttribute('id', PORTAL_ID)
      newPortal.classList.add('Toaster')

      document.body.appendChild(newPortal)
      portalElement = newPortal
    }

    return portalElement
  }
}

/**
 * @function
 * @name Toaster
 * @description Toaster function
 * @example
 * Toaster.notify()
 * @tutorial https://flora.gb.tech/docs/components/core/toast
 */
export const Toaster = new ToasterBuilder()
